import {
  BusinessUnitKey,
  DEFAULT_DASHBOARD_ROUTE_NAME,
  DEFAULT_LOGIN_ROUTE_NAME,
  DEFAULT_SELECT_ACCOUNT_ROUTE_NAME,
  type BusinessUnitConfig,
} from '@/modules/bu/bu.types';
import { retainedAuthorizationPrefixes } from './integrations/storage';

// This product's entry in the BU registry, which discovers it by filename.
// Nothing outside this folder lists Flokee: deleting the folder removes the
// product from the app.
export const config: BusinessUnitConfig = {
  key: BusinessUnitKey.Flokee,
  order: 1,
  label: 'Flokee',
  basePath: '/flokee',
  // Domain routing only applies in production.
  domain: import.meta.env.VITE_APP_FLOKEE_URL,
  dashboardRouteName: DEFAULT_DASHBOARD_ROUTE_NAME,
  loginRouteName: DEFAULT_LOGIN_ROUTE_NAME,
  selectAccountRouteName: DEFAULT_SELECT_ACCOUNT_ROUTE_NAME,
  investRouteName: 'InvestView',
  helpCenterUrl: 'https://help.flokee.ai/introduccion',
  websiteUrl: 'https://flokee.ai',
  // ponytail: Anigamy has no privacy policy URL yet, so Flokee keeps today's
  // engeni.com page rather than shipping a 404. Swap it when FLOK-1644 supplies one.
  privacyPolicyUrl: 'https://engeni.com/privacy.html',
  supportsTiendanubeSignIn: true,
  showsPlanInvestment: true,
  chooserDescriptionKey: 'common.choose_business_unit_flokee_description',
  cartSelectI18nPrefix: 'cart_select',
  orbitPathTemplate: '/flok/ecommerce/:id/info',
  logoPath: '/images/logo.svg',
  retainedStoragePrefixes: retainedAuthorizationPrefixes,
  faviconPath: '/favicon/favicon-flokee.ico',
};
